//https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=HyMW%2BWP%20Kolkata%20India&destinations=GCG2%2B3M%20Kolkata%20India&key=AIzaSyDWHwImfa_wQA1w43SUupEvSxo8eCfnUPo

export default function getDistance(origin, destination) {
  return dispatch => {
    let fbCloudUrl =
      "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&";

    let og = "origins=" + encodeURIComponent(origin);
    let dst = "destinations=" + encodeURIComponent(destination);

    let fetchQuery =
      fbCloudUrl +
      og +
      "&" +
      dst +
      "&key=AIzaSyDWHwImfa_wQA1w43SUupEvSxo8eCfnUPo";
    return fetch(fetchQuery, {
      method: "GET"
    })
      .then(res => res.json())
      .then(parsedRes => {
        return parsedRes;
      })
      .catch(err => {
        console.log("Could not fetch distance" + err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/Firebase/Generic/getDistance.js